import classNames from 'classnames';

import { FavoriteFilledIcon, FavoriteIcon } from '../../icons';

import styles from './_index.module.scss';

export interface FavoriteToggleProps {
  'aria-label'?: string;
  isFavorite?: boolean;
  onChange?: () => void;
}

const FavoriteToggle = ({ 'aria-label': ariaLabel, isFavorite, onChange }: FavoriteToggleProps) => {
  const icon = isFavorite ? <FavoriteFilledIcon /> : <FavoriteIcon />;
  const className = classNames(styles['favorite-toggle'], {
    [styles['is-favorite']]: isFavorite,
  });

  if (!onChange) {
    return (
      <span aria-hidden="true" className={className}>
        {icon}
      </span>
    );
  }

  return (
    <button
      aria-label={ariaLabel || (isFavorite ? 'Remove from favorites' : 'Add to favorites')}
      aria-pressed={Boolean(isFavorite)}
      className={className}
      onClick={onChange}
      type="button"
    >
      <span aria-hidden="true">{icon}</span>
    </button>
  );
};

export default FavoriteToggle;
